// extracted by mini-css-extract-plugin
export default {"container":"UserPosts_container__5PuOA"};